"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var route_service_1 = require("../core/route.service");
var i18n_service_1 = require("../core/i18n.service");
var patient_selection_component_1 = require("./patient-selection.component");
var routes = route_service_1.Route.withShell([
    { path: 'patient-selection', component: patient_selection_component_1.PatientSelectionComponent, data: { title: i18n_service_1.extract('Patient selection') } }
]);
var PatientSelectionRoutingModule = /** @class */ (function () {
    function PatientSelectionRoutingModule() {
    }
    PatientSelectionRoutingModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forChild(routes)],
            exports: [router_1.RouterModule],
            providers: []
        })
    ], PatientSelectionRoutingModule);
    return PatientSelectionRoutingModule;
}());
exports.PatientSelectionRoutingModule = PatientSelectionRoutingModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aWVudC1zZWxlY3Rpb24ucm91dGluZy5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXRpZW50LXNlbGVjdGlvbi5yb3V0aW5nLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBeUM7QUFDekMsMENBQXVEO0FBRXZELHVEQUE4QztBQUM5QyxxREFBK0M7QUFDL0MsNkVBQTBFO0FBRTFFLElBQU0sTUFBTSxHQUFXLHFCQUFLLENBQUMsU0FBUyxDQUFDO0lBQ25DLEVBQUMsSUFBSSxFQUFFLG1CQUFtQixFQUFFLFNBQVMsRUFBRSx1REFBeUIsRUFBRSxJQUFJLEVBQUUsRUFBQyxLQUFLLEVBQUUsc0JBQU8sQ0FBQyxtQkFBbUIsQ0FBQyxFQUFDLEVBQUM7Q0FDakgsQ0FBQyxDQUFDO0FBT0g7SUFBQTtJQUNBLENBQUM7SUFEWSw2QkFBNkI7UUFMekMsZUFBUSxDQUFDO1lBQ04sT0FBTyxFQUFFLENBQUMscUJBQVksQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUM7WUFDeEMsT0FBTyxFQUFFLENBQUMscUJBQVksQ0FBQztZQUN2QixTQUFTLEVBQUUsRUFBRTtTQUNoQixDQUFDO09BQ1csNkJBQTZCLENBQ3pDO0lBQUQsb0NBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSxzRUFBNkIifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/patient-selection/patient-selection.routing.module.ts
// module id = 627
// module chunks = 0